import React, { Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Button from '../../../atoms/button';
import ConfigurationHeader from '../../../components/configuration_header';
import {
  renameConfiguration, cancelConfiguration,
  clearSoftwareLicenseInformations,
  setActiveStep, addAccessoryCartToMultipleModules, preSaveConfiguration, removeIslandModuleOption, removeModuleOption, addSubAccessory, removeSubAccessory,
} from '../../configuration-management/ducks';
import { openModal, closeModal } from '../../modals/ducks';
import { stepsConfig, configurationStatuses, possible_starter_selections, surveyTypes, surveyEventTypes, eventForceShowingSurvey, OPTION_CATEGORIES, LICENSE_MODELS } from '../../../constants';
import { getStepperLabels } from '../../../utils/linear-stepper';
import I10n from '../../../features/i10n';
import Configuration from '../../../models/Configuration';
import { getAccessories } from '../../get-accessories/ducks';
import RulesDisplayer from '../../../components/rules_displayer';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { appConfiguration } from '../../../utils/app-starter';
import { showNotificationWithButton } from '../../notification/ducks';
import ApplicationFullHeader from '../../../components/application_full_header';
import Scrollbars from 'react-custom-scrollbars';
import LoadingSpinner from '../../../atoms/loading';
import { getSurvey } from '../../survey-management/ducks';
import Survey from '../../../components/survey';
import { exportToMyProduct, exportToMyProject } from '../../export/ducks';
import { getCartUrl } from '../../../utils/my-product';
import AddToMyProductButton from '../../../components/add_to_my_product_button';
import { logSurveyOpenEvent, logSurveySubmitEvent } from '../../../utils/analytics-logger';
import { resetCBRSelectedItems } from '../../call-by-range/ducks';
import { updateShowButtonAnimations } from '../start_configuration_screen/ducks';
import { buildMySchneiderUrl } from '../../../utils/url-builder';
import OptionsSelector, { OPTIONS_SELECTOR_DISPLAY_MODES } from '../../../components/options_selector';
import ProductLink from '../../../components/product_link';
import ProductInformationCache from '../../../persistence/description-cache';
import Notification from '../../notification';
import ModalHardwareToSoftware from '../../modals/modal-hardware-to-software';
import MsxIcons from '../../msx-icons';
import { PRIMARY_COLOR } from '../../../color-constants';
import Accordion from '../../../components/accordion';
import { shouldDisplaySoftwareLicenseData } from '../../../utils/software-licenses';
import { SHOW_HARDWARE_TO_SOFTWARE } from '../../../feature-constants';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0;left: 0;right:0;bottom: 0;
    overflow: auto;
    background-color: white;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0;left: 0;right:0;bottom: 0;
    overflow: auto;
    background-color: white;
    padding: 0px;
  `}
`;

const FullScreenScrollbarWrapper = styled.div`
`;

const ScreenContent = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  padding: 0px 40px 0px 16px;
  position: relative;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  margin: 0px -16px 10px -16px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const MainSection = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: 0px 8px 40px 0px #00000040;
  border-radius: 12px;
  padding: 10px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const AddLicenseWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1 1 0px;
  margin-left: 10px;
`;

const Title = styled.span`
  color: #000000;
  font-size: 30px;
  font-weight: 400;
`;

const SubTitle = styled.span`
  color: #000000;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 20px;
`;

const FullScreenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transform: translate3d(0,0,0);
  border-top: 2px solid #EDEDED;
  background-color: white;
`;

const HiddenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  background-color: white;
  border-top: 2px solid #EDEDED;
  visibility: hidden;
`;

const NavigationButtonRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.mBottom && `margin-bottom: ${props.mBottom}px;`}
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

const SoftwareAndClearWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const SoftwareTitle = styled.div`
 color: #000000;
  font-size: 18px;
  font-weight: 400;
  margin-right: 10px;
`;

const ClearPositioner = styled.div`
  display: flex;
  flex: 1 1 0px;
  justify-content: flex-end;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
`;

const ClearWrapper = styled.div`
  cursor: pointer;
  ${props => props.$disabled ? `
    opacity: 0.5;
    pointer-events: none;
  ` : ''}
`;

const ClearIconWrapper = styled.div`
  display: inline-block;
  margin-right: 5px;
  --se-icon-size: 20px;
`;

const SoftwareLicensesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

const SoftwareLicenseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

const SoftwareLicenseLinkWrapper = styled.div`
`;

const SoftwareLicenseDescription = styled.span`
  color: #333333;
  font-weight: 400;
  margin-top: 5px;
`;

const LicenseItemQuantityLabel = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #626469;
  margin-top: 5px;
`;

const displayModes = {
  all: 0,
  recommanded_only: 1,
  specificIsland: 2
}

class AccessorizeScreen extends React.Component {

  get defaultAccessoryCart() {
    return Object.assign({}, {
      accessories: {},
      auxiliaries: {},
      sensors: {},
      spareParts: {},
      options: {}
    })
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedModuleOptions: null,
      accessoryCategorySelected: null,
      isDesktop: window.innerWidth > 800,
      search: '',
      displayMode: displayModes.all,
      slotSpecificIslandToDisplay: null,
      accessoryCart: this.defaultAccessoryCart,
      optionsAvailable: {},
      optionsLoading: false,
      showHardwareToSoftware: false
    };
    this._isMounted = false;
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  retrieveAvailableOptions = () => {
    const moduleMap = {};
    this.eligibleIslandCategories().forEach((category) => {
      Object.values(category.moduleItems).forEach((module) => {
        moduleMap[module.id] = module;
      });
    });

    const promises = [];
    Object.values(moduleMap).forEach(mod => {
      promises.push(
        this.getOptions(mod.id, mod.recommandedAccessories, mod.mandatoryAccessories, {}, true, () => 0).then((res) => {
          const newOptionsAvailable = JSON.parse(JSON.stringify(this.state.optionsAvailable));
          newOptionsAvailable[mod.id] = res;
          this.updateStateIfMounted({optionsAvailable: newOptionsAvailable});
        })
      );
    });

    this.updateStateIfMounted({optionsLoading: true});
    Promise.all(promises).finally(() => {
      this.updateStateIfMounted({optionsLoading: false});
    });
  }

  componentDidMount = () => {
    this.props.getSurvey().then(() => {
      if (this.props.showButtonAnimations?.survey) {
        window.dispatchEvent(new Event(eventForceShowingSurvey));
      }
    }).finally(() => {
      this.props.updateShowButtonAnimations();
    });
    window.addEventListener("resize", this.updateIsDesktop);
    this._isMounted = true;

    this.retrieveAvailableOptions();
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateIsDesktop);
    this._isMounted = false;
    this.props.closeModal();
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  showDuplicateConfirmationModal = (callback) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    if (isSaved && !this.props.configuration.allowSavedModifications) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            callback();
          },
          title: I10n.get('modal.change_saved_configuration.title'),
          text: I10n.get('modal.change_saved_configuration.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      callback();
    }
  }

  removeModuleAccessory = (targetSlot, islandSlot, rackLocation, moduleType, accessory, accessoryType) => {
    return new Promise((resolve, reject) => {
      this.showDuplicateConfirmationModal(() => {
        if (islandSlot !== 0) {
          this.props.removeIslandModuleOption(this.props.configuration, islandSlot, rackLocation, accessoryType, targetSlot,  moduleType, accessory).then(() => {
            resolve();
          });
        } else {
          this.props.removeModuleOption(this.props.configuration, rackLocation, accessoryType, targetSlot, moduleType, accessory).then(() => {
            resolve();
          });
        }
      });
    });
  }

  renderHeaderContent = (config) => {
    return (
      <HeaderContent>
        <ConfigurationHeader
          configuration={config}
          setConfigurationName={(name) => {
            this.props.renameConfiguration(config.id, name)
          }}
          isLoading={this.props.configurationSaver.isSaving}
          renderRangeRules={this.renderRangeRules}
        >
        </ConfigurationHeader>
      </HeaderContent>
    );
  }

  eligibleIslandCategories = () => {
    const config = new Configuration(this.props.configuration);
    const islandCategories = config.extractDistinctDevicesForAccesorization();
    const result = [];

    islandCategories.forEach(islandCat => {
      const keys = Object.keys(islandCat.moduleItems);
      const toRemove = [];
      for (let i = 0; i < keys.length; i++) {
        if ((this.state.displayMode === displayModes.recommanded_only && islandCat.moduleItems[keys[i]].recommandedAccessories.length === 0)) {
          toRemove.push(keys[i]);
        }
      }

      for (let key of toRemove) {
        delete islandCat.moduleItems[key];
      }

      // If there is at least one module category to show, return the island else hide it.
      if (toRemove.length !== keys.length && (displayModes.specificIsland !== this.state.displayMode || islandCat?.islandSlot === this.state.slotSpecificIslandToDisplay)) {
        result.push(islandCat);
      }
    });

    return result;
  }

  previewConfigurationWithDevice = (moduleSlot, moduleType, moduleIslandSlot, moduleRackLocation) => {
    const config = new Configuration(this.props.configuration);
    let modalType = 'preview-configuration';
    if (this.props.configuration.starterType === possible_starter_selections.PAC) {
      modalType = 'preview-pac-configuration';
    } else if (this.props.configuration.starterType === possible_starter_selections.EDGE) {
      modalType = 'preview-edge-configuration';
    }

    this.props.openModal({
      modalType,
      modalProps: {
        configuration: config,
        moduleToHighlightProps: {
          moduleSlot,
          moduleType,
          moduleIslandSlot,
          moduleRackLocation
        }
      }
    });
  }

  getAccessoryCategoryTitle = (label) => {
    let title = '';
    switch (label) {
      case OPTION_CATEGORIES.ACCESSORIES:
        title = I10n.get('screen.config_editor.accessories');
        break;
      case OPTION_CATEGORIES.AUXILIARIES:
        title = I10n.get('screen.config_editor.auxiliaries_default');
        break;

      case OPTION_CATEGORIES.SENSORS:
        title = I10n.get('screen.config_editor.sensors');
        break;
      case OPTION_CATEGORIES.SPARE_PARTS:
        title = I10n.get('screen.config_editor.spare_parts');
        break;
      case OPTION_CATEGORIES.OPTIONS:
        title = I10n.get('screen.config_editor.options');
        break;
      case OPTION_CATEGORIES.WARRANTIES:
        title = I10n.get('screen.config_editor.warranty');
        break;
      default:
    }
    return title;
  }

  getOptionStatus = (acc, recommandedAccessories, mandatoryAccessories) => {
    let status = 'normal';

    if (mandatoryAccessories.includes(acc)) {
      status = 'mandatory';
    } else if (recommandedAccessories.includes(acc)) {
      status = 'recommanded';
    }

    return status;
  }

  computeActionStatusForCandidateOption = (categoryKey, currentQuantityForRef, canUpdateQuantity) => {
    let result = {
      canAdd: true,
      canIncrease: canUpdateQuantity,
      canDecrease: canUpdateQuantity,
      canRemove: canUpdateQuantity && currentQuantityForRef> 0
    };

    if (categoryKey === OPTION_CATEGORIES.WARRANTIES) {
      result = {
        canAdd: true,
        canIncrease: false,
        canDecrease: false,
        canRemove: currentQuantityForRef> 0
      };
    }

    return result;
  }

  computeSubAccessoryQuantity = (device) => {
    return (accessoryId, subAccessoryId) => {
      return device.extractSelectedSubAccessoryQuantityForAccessory(accessoryId, subAccessoryId);
    };
  }

  getOptions = (deviceId, recommandedAccessories, mandatoryAccessories, addedAccessoriesQuantity, canUpdateQuantity, getSubAccessyQuantityForModuleFct) => {
    return this.props.getAccessories(deviceId).then((response) => {
      const optionsObj = {
        accessories: [],
        services: []
      };
      Object.keys(response).forEach(responseKey => {
        const responseCategories = response[responseKey];

        const optionCategories = {};
        Object.keys(responseCategories).forEach((key) => {
          const accessoriesForKey = responseCategories[key];
          if (accessoriesForKey.length > 0) {
            optionCategories[key] = {
              categoryKey: key,
              categoryLabel: this.getAccessoryCategoryTitle(key),
              isFinal: true,
              options: accessoriesForKey.map((acc) => {
                const quantity = (addedAccessoriesQuantity && addedAccessoriesQuantity[key] && addedAccessoriesQuantity[key][acc.id]) ? addedAccessoriesQuantity[key][acc.id] : 0;
                const actionStatuses = this.computeActionStatusForCandidateOption(key, quantity, canUpdateQuantity);
                const subAccessories = acc.subAccessories.reduce((obj, subAcc) => {

                  const subAccessoryQuantity = getSubAccessyQuantityForModuleFct(acc.id, subAcc.id);
                  obj[subAcc.id] = {
                    subAccessoryIdentification: {
                      id: subAcc.id
                    },
                    id: subAcc.id,
                    getOptionDescription: () => ProductInformationCache.getDescription(subAcc.id),
                    quantity: subAccessoryQuantity,
                    imageUrl: `https://gw-api.schneider-electric.com/sc/products/image/${subAcc.id}?width=80&height=80`,
                    status: subAcc.status,
                    canAdd: true,
                    canIncrease: (subAccessoryQuantity < subAcc.maxQty),
                    canDecrease: (subAccessoryQuantity > subAcc.minQty),
                    canRemove: subAcc.minQty === 0,
                  };
                  return obj;
                }, {});
                return (
                  {
                    optionIdentification: {
                      identificationKey: acc.id,
                      id: acc.id,
                      type: acc.type,
                      optionType: key,
                      optionCategory: responseKey
                    },
                    id: acc.id,
                    getOptionDescription: () => ProductInformationCache.getDescription(acc.id),
                    imageUrl: `https://gw-api.schneider-electric.com/sc/products/image/${acc.id}?width=80&height=80`,
                    canAdd: actionStatuses.canAdd,
                    disabledMessage: '',
                    canIncrease: (acc.type !== 'UPS') && actionStatuses.canIncrease,
                    canDecrease: actionStatuses.canDecrease,
                    canRemove: actionStatuses.canRemove,
                    quantity,
                    status: this.getOptionStatus(acc.id, recommandedAccessories, mandatoryAccessories),
                    subAccessories,
                  }
                );
              })
            };
          }
        });

        if (Object.keys(optionCategories).length > 0) {
          optionsObj[responseKey].push({
            optionCategories
          });
        }
      });
      return optionsObj;
    });
  }

  computeActionStatusForSelectedOption = (categoryKey, isMandatory) => {
    let result = {
      canIncrease: true,
      canDecrease: true,
      canRemove: !isMandatory
    };

    if (categoryKey === OPTION_CATEGORIES.WARRANTIES) {
      result = {
        canIncrease: false,
        canDecrease: false,
        canRemove: !isMandatory
      };
    }

    return result;
  }

  extractSelectedOptions = (mod, recommandedAccessories, mandatoryAccessories) => {
    const result = {};
    const selectedOptionsCategories = mod.device.extractSelectedOptions();
    Object.keys(selectedOptionsCategories).forEach(key => {
      result[key] = [];
      selectedOptionsCategories[key].forEach((opt) => {
        const isMandatory = mandatoryAccessories.includes(opt.id);
        const actionStatus = this.computeActionStatusForSelectedOption(opt.accessoryType, isMandatory);
        const subAccessories = opt.subAccessories.map(subAcc => {
          return {
            subAccessoryIdentification: {
              id: subAcc.id
            },
            id: subAcc.id,
            description: ProductInformationCache.getDescription(subAcc.id),
            quantity: subAcc.quantity,
            canIncrease: subAcc.quantity < subAcc.maxQty,
            canDecrease: subAcc.quantity > subAcc.minQty,
            canRemove: subAcc.minQty === 0,
          };
        });

        result[key].push({
          optionIdentification: {
            identificationKey: opt.id,
            id: opt.id,
            type: opt.type,
            optionType: opt.accessoryType,
            optionCategory: key
          },
          id: opt.id,
          quantity: opt.quantity,
          subAccessories: subAccessories,
          description: ProductInformationCache.getDescription(opt.id),
          status: this.getOptionStatus(opt.id, recommandedAccessories, mandatoryAccessories),
          canShowInModal: true,
          canIncrease: opt.type !== 'UPS' && actionStatus.canIncrease,
          onIncrease: (deviceIdentification, accessoryIdentification, quantity) => {
            return this.addOptions(deviceIdentification, accessoryIdentification, quantity, [deviceIdentification.moduleSlot]);
          },
          canDecrease: actionStatus.canDecrease,
          onDecrease: (deviceIdentification, accessoryIdentification, quantity) => {
            return this.addOptions(deviceIdentification, accessoryIdentification, -quantity, [deviceIdentification.moduleSlot]);
          },
          canRemove: actionStatus.canRemove,
          onRemove: (deviceIdentification, accessoryIdentification) => {
            this.removeModuleAccessory(deviceIdentification.moduleSlot, deviceIdentification.islandSlot, deviceIdentification.rackLocation, deviceIdentification.moduleType, accessoryIdentification.id, accessoryIdentification.optionType);
          },
        });
      });
    });
    return result;
  }

  addOptions = (deviceIdentification, accessoryIdentification, quantity, moduleSlots) => {
    return new Promise((resolve, reject) => {
      this.showDuplicateConfirmationModal(() => {
        this.props.addAccessoryCartToMultipleModules(this.props.configuration, deviceIdentification.moduleId, deviceIdentification.islandSlot, deviceIdentification.rackLocation, deviceIdentification.moduleType, {[accessoryIdentification.optionType]: {[accessoryIdentification.id] : {quantity: quantity, type: accessoryIdentification.type}}}, moduleSlots).then(() => {
          resolve();
        }).catch(e => { });
      });
    });
  }

  extractModules = (moduleItem) => {
    const modules = [];
    if (moduleItem.modules) {
      moduleItem.modules.forEach((mod) => {
        modules.push({
          deviceIdentification: {
            identificationKey: mod.device.id + '_' + mod.islandSlot + '_' + mod.device.slot,
            moduleId: mod.device.id,
            moduleSlot: mod.device.slot,
            rackLocation: mod.rackLocation,
            islandSlot: mod.islandSlot,
            moduleType: mod.device.moduleType,
            moduleMetadata: mod
          },
          location: {
            label: I10n.getAndReplace('screen.accessorize_screen.location', mod.device.slot),
            onClick: () => {
              this.previewConfigurationWithDevice(mod.device.slot, mod.device.moduleType, mod.islandSlot, mod.rackLocation);
            }
          },
          selectedOptions: this.extractSelectedOptions(mod, moduleItem.recommandedAccessories, moduleItem.mandatoryAccessories),
          id: mod.device.id,
          getOptions: () => { return this.getOptions(mod.device.id, moduleItem.recommandedAccessories, moduleItem.mandatoryAccessories, mod.device.extractOptionsWithQuantity(), true, this.computeSubAccessoryQuantity(mod.device)); },
          onAddOptions: (deviceIdentification, accessoryIdentification, quantity) => {
            return this.addOptions(deviceIdentification, accessoryIdentification, quantity, [deviceIdentification.moduleSlot]);
          },
          onDecreaseOptions: (deviceIdentification, accessoryIdentification, quantity) => {
            return this.addOptions(deviceIdentification, accessoryIdentification, -quantity, [deviceIdentification.moduleSlot]);
          },
          onRemoveOptions: (deviceIdentification, accessoryIdentification) => {
            return this.removeModuleAccessory(deviceIdentification.moduleSlot, deviceIdentification.islandSlot, deviceIdentification.rackLocation, deviceIdentification.moduleType, accessoryIdentification.id, accessoryIdentification.optionType);
          },
          onAddSubAccessories: (deviceIdentification, accessoryIdentification, subAccessoryIdentification, quantity) => {
            return this.props.addSubAccessory(this.props.configuration, [deviceIdentification.moduleSlot], deviceIdentification.moduleType, accessoryIdentification, subAccessoryIdentification, quantity, deviceIdentification.islandSlot, deviceIdentification.rackLocation)
            .catch(error => {
              console.log("addSubAccessory error A", error);
            });
          },
          onDecreaseSubAccessories: (deviceIdentification, accessoryIdentification, subAccessoryIdentification, quantity) => {
            return this.props.addSubAccessory(this.props.configuration, [deviceIdentification.moduleSlot], deviceIdentification.moduleType, accessoryIdentification, subAccessoryIdentification, -quantity, deviceIdentification.islandSlot, deviceIdentification.rackLocation)
              .catch(error => {
                console.log("decreaseSubAccessory error A", error);
              });
          },
          onRemoveSubAccessories: (deviceIdentification, accessoryIdentification, subAccessoryIdentification) => {
            return this.props.removeSubAccessory(
                this.props.configuration,
                [deviceIdentification.moduleSlot],
                deviceIdentification.moduleType,
                accessoryIdentification,
                subAccessoryIdentification,
                deviceIdentification.islandSlot,
                deviceIdentification.rackLocation
            ).catch(error => {
                console.error("Error removing sub accessory:", error);
            });
        },

          description: ProductInformationCache.getDescription(mod.device.id),
          imageUrl: `https://gw-api.schneider-electric.com/sc/products/image/${mod.device.id}?width=80&height=80`,
        });
      });
    }
    return modules;
  }

  extractModuleItems = (category) => {
    const moduleItems = [];
    const categoryModuleItems = category.moduleItems;
    Object.keys(categoryModuleItems).forEach(key => {

      const id = categoryModuleItems[key].id;
      const hasRecommendedOptions = categoryModuleItems[key].recommandedAccessories?.length > 0;

      const modules = this.extractModules(categoryModuleItems[key]);
      const categoryModulesSlots = [...modules.map(m => m.deviceIdentification.moduleSlot)];

      moduleItems.push({moduleId: id,
        description: ProductInformationCache.getDescription(id),
        onAddOptions: (deviceIdentification, accessoryIdentification, quantity, modulesForBulk) => {
          const modulesSlotsToAddOptions = [...modules.map(m => m.deviceIdentification).filter(deviceIdentification => modulesForBulk.includes(deviceIdentification.identificationKey)).map(deviceIdentification => deviceIdentification.moduleSlot)];
          return this.addOptions(deviceIdentification, accessoryIdentification, quantity, modulesSlotsToAddOptions);
        },
        onDecreaseOptions: (deviceIdentification, accessoryIdentification, quantity) => {
          return this.addOptions(deviceIdentification, accessoryIdentification, -quantity, categoryModulesSlots);
        },
        onRemoveOptions: (deviceIdentification, accessoryIdentification) => {
          return this.removeModuleAccessory(deviceIdentification.moduleSlot, deviceIdentification.islandSlot, deviceIdentification.rackLocation, deviceIdentification.moduleType, accessoryIdentification.id, accessoryIdentification.optionType);
        },
        onAddSubAccessories: (deviceIdentification, accessoryIdentification, subAccessoryIdentification, quantity) => {
          return this.props.addSubAccessory(this.props.configuration, categoryModulesSlots, deviceIdentification.moduleType, accessoryIdentification, subAccessoryIdentification, quantity, deviceIdentification.islandSlot, deviceIdentification.rackLocation)
          .catch(error => {
            console.log("addSubAccessory error B", error);
          });
        },
        onRemoveSubAccessories: (deviceIdentification, accessoryIdentification, subAccessoryIdentification) => {
          return this.props.removeSubAccessory(
            this.props.configuration,
            categoryModulesSlots,
            deviceIdentification.moduleType,
            accessoryIdentification,
            subAccessoryIdentification,
            deviceIdentification.islandSlot,
            deviceIdentification.rackLocation,
          ).catch(error => {
            console.error("Error removing sub accessory:", error);
          });
        },
        onDecreaseSubAccessories: (deviceIdentification, accessoryIdentification, subAccessoryIdentification, quantity) => {
          return this.props.addSubAccessory(this.props.configuration, categoryModulesSlots, deviceIdentification.moduleType, accessoryIdentification, subAccessoryIdentification, -quantity, deviceIdentification.islandSlot, deviceIdentification.rackLocation)
          .catch(error => {
            console.log("decreaseSubAccessory error B", error);
          });
        },
        deviceIdentification: {
          identificationKey: key + '_' + category.islandSlot,
          moduleId: key,
          rackLocation: category.rackLocation,
          islandSlot: category.islandSlot,
          moduleType: modules[0].deviceIdentification.moduleType,
          moduleSlot: modules[0].deviceIdentification.moduleSlot,
          moduleMetadata: {
            moduleId: id,
            islandSlot: category.islandSlot
          }
        },
        imageUrl: `https://gw-api.schneider-electric.com/sc/products/image/${id}?width=80&height=80`,
        modules,
        order: categoryModuleItems[key].categoryIdx,
        hasRecommendedOptions,
        optionsLoading: this.state.optionsLoading,
        optionsAvailable: this.state.optionsAvailable[id],
        getOptions: () => { return this.getOptions(id, categoryModuleItems[key].recommandedAccessories, categoryModuleItems[key].mandatoryAccessories, (modules.length === 1) ? modules[0].deviceIdentification.moduleMetadata.device.extractOptionsWithQuantity(): {}, modules.length === 1, (modules.length === 1) ? this.computeSubAccessoryQuantity(modules[0].deviceIdentification.moduleMetadata.device) : () => 0); },
      });
    });

    moduleItems.sort((a, b) => a.categoryIdx - b.categoryIdx);
    return moduleItems;
  }

  // Perform transformation for the options shared component.
  buildSharedCategories = () => {
    const islandCategories = this.eligibleIslandCategories();
    const newCategories = [];

    islandCategories.forEach((category) => {
      newCategories.push(
        {categoryName: category.islandName,
         moduleItems: this.extractModuleItems(category)
        }
      );
    });
    return newCategories;
  }

  renderSoftwareLicenseSelections = (config) => {
    return (<Fragment>
      {config.softwareLicenseSelections.map((softwareSelection, idx) => {
        const translatedSoftwareName = I10n.getOrDefault(`screen.licence_selector.${softwareSelection.softwareSelection}.title`, softwareSelection.softwareSelection);
        return (<Fragment key={idx}>
        <SoftwareAndClearWrapper>
          <SoftwareTitle>{translatedSoftwareName}</SoftwareTitle>
          <ClearPositioner>
            <ClearWrapper $disabled={this.props.configurationSaver.isSaving} onClick={() => {
              this.showDuplicateConfirmationModal(() => {
                this.props.openModal({
                  modalType: 'confirmation',
                  modalProps: {
                    onCancel: () => { this.props.closeModal(); },
                    onSubmit: () => {
                      this.props.clearSoftwareLicenseInformations(softwareSelection.softwareSelection).then(() => {
                        this.props.closeModal();
                      });
                    },
                    title: I10n.get('app.action.clear'),
                    text: I10n.getAndReplace('screen.accessorize_screen.clear_software_selection', translatedSoftwareName),
                    cancelText: I10n.get('app.action.cancel'),
                    submitText: I10n.get('app.action.continue'),
                  }
                });
              })
            }}>
              <ClearIconWrapper>
                <MsxIcons name="replace" size="small"></MsxIcons>
              </ClearIconWrapper>
              {I10n.get('screen.accessorize_screen.clear_selection')}
            </ClearWrapper>
          </ClearPositioner>
        </SoftwareAndClearWrapper>
          {this.renderSoftwareLicenses(softwareSelection.softwareLicences, softwareSelection.servicePlanItems, softwareSelection.licenseModel, softwareSelection.servicePlanActivated)}
        </Fragment>);
      })}
    </Fragment>);
  }

  renderSoftwareLicenses = (licenses, servicePlans, licenseModel, servicePlanActivated) => {
    return (
      <SoftwareLicensesWrapper>
        {licenses.map((softwareLicence, idx) => {
          return (
            <SoftwareLicenseWrapper key={idx}>
              <SoftwareLicenseLinkWrapper>
                <ProductLink reference={softwareLicence.id} disabled={LICENSE_MODELS.SUBSCRIPTION === licenseModel}></ProductLink>
              </SoftwareLicenseLinkWrapper>
              <SoftwareLicenseDescription>{ProductInformationCache.getDescription(softwareLicence.id)}</SoftwareLicenseDescription>
              <LicenseItemQuantityLabel>{`${I10n.get('bom.qty')} ${softwareLicence.quantity || 0}`}</LicenseItemQuantityLabel>
            </SoftwareLicenseWrapper>
          );
        })}
        {servicePlanActivated && servicePlans.map((servicePlan, idx) => {
           return (
            <SoftwareLicenseWrapper key={idx}>
              <SoftwareLicenseLinkWrapper>
                <ProductLink reference={servicePlan.id} disabled={true}></ProductLink>
              </SoftwareLicenseLinkWrapper>
              <SoftwareLicenseDescription>{ProductInformationCache.getDescription(servicePlan.id)}</SoftwareLicenseDescription>
              <LicenseItemQuantityLabel>{`${I10n.get('bom.service_plan_size')} ${servicePlan.quantity || 0}`}</LicenseItemQuantityLabel>
            </SoftwareLicenseWrapper>
          );
        })}
      </SoftwareLicensesWrapper>
    );
  }

  renderProducts = (config, moduleCategories) => {
    const softwareLicenseSelections = config.softwareLicenseSelections;

    let categoryDisplayMode = OPTIONS_SELECTOR_DISPLAY_MODES.CLASSIC;
    if (softwareLicenseSelections.length > 0) {
      categoryDisplayMode = OPTIONS_SELECTOR_DISPLAY_MODES.DROPDOWN;
    }
    const optionsSelector = (
      <OptionsSelector
          moduleCategories={moduleCategories}
          isSaving={this.props.configurationSaver.isSaving}
          renderProductLink={(referenceId) => <ProductLink reference={referenceId}></ProductLink>}
          getLabel={(key) => I10n.get(key)}
          getAndReplaceLabel={(key, value) => I10n.getAndReplace(key, value)}
          mobileBreakpoint={800}
          primaryColor={appConfiguration.globalStyles.primaryColor}
          secondaryColor={appConfiguration.globalStyles.secondaryColor}
          categoryDisplayMode={categoryDisplayMode}
        >
        </OptionsSelector>
    );

    if (softwareLicenseSelections.length > 0) {
      return (
        <>
          <Accordion defaultOpenStatus={true}
            title={I10n.get('screen.config_editor.software')}
            content={this.renderSoftwareLicenseSelections(config)}>
          </Accordion>
          {optionsSelector}
        </>
      );
    }

    return <>
      {moduleCategories.length > 0 && optionsSelector}
    </>
  }

  shouldShowHardwareToSoftwareCapability = () => {
    return SHOW_HARDWARE_TO_SOFTWARE
      && (this.props.configuration.hardwareToSoftwareCompatibilities || []).length > 0
      && shouldDisplaySoftwareLicenseData();
  }


  renderMainSection = (config) => {
    const moduleCategories = this.buildSharedCategories();

    return (
      <ContentWrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          <MainSection>
            <CardWrapper>
              <TitleWrapper>
                <Title>{I10n.get('app.stepper.accessorize')}</Title>
                {this.shouldShowHardwareToSoftwareCapability() && <AddLicenseWrapper>
                  <Button
                    disabled={this.props.configurationSaver.isSaving}
                    importance="emphasized"
                    icon-name={'plus-large'}
                    onClick={() => {
                      this.showDuplicateConfirmationModal(() => {
                        this.updateStateIfMounted({
                          showHardwareToSoftware: true
                        });
                      });
                    }}
                  >
                    {I10n.get('screen.accessorize_screen.add_software_license')}
                  </Button>
                </AddLicenseWrapper>}
              </TitleWrapper>
              <SubTitle>{I10n.get('screen.accessorize_screen.subtitle')}</SubTitle>
              {this.renderProducts(config, moduleCategories)}
            </CardWrapper>
          </MainSection>
          {this.state.showHardwareToSoftware && <ModalHardwareToSoftware
            closeModal={() => {
              this.updateStateIfMounted({
                showHardwareToSoftware: false
              });
            }}
          >
          </ModalHardwareToSoftware>}
      </ContentWrapper>
    );
  }

  confirmationBeforeCancel = (isSaved, cancelCallback) => {
    if (!isSaved) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            cancelCallback();
            this.props.cancelConfiguration(this.props.configuration.id);
            this.props.closeModal();
          },
          title: I10n.get('screen.config_editor.modal_cancel.title'),
          text: I10n.get('screen.config_editor.modal_cancel.body'),
          cancelText: I10n.get('app.action.return'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    } else {
      cancelCallback();
    }
  }

  getStepperActions = (isSaved) => {
    const config = new Configuration(this.props.configuration);

    return [
      { action: () => { this.confirmationBeforeCancel(isSaved, this.props.backToStart); }, active: true, done: true, hidden: appConfiguration.disableCallByRangeBackToStart },
      { action: () => {
        if (this.props.callByRangeReducer?.selectedItems?.references && Object.keys(this.props.callByRangeReducer?.selectedItems?.references).length === 1) {

          this.props.openModal({
            modalType: 'confirmation',
            modalProps: {
              onCancel: () => { this.props.closeModal(); },
              onSubmit: () => {
                this.props.resetCallByRangeSelectedItems();
                this.props.closeModal();
                if (configurationStatuses.finished === this.props.configuration.status) {
                  this.props.setActiveStep(stepsConfig.head_device_selector_screen);
                } else {
                  this.props.preSaveConfiguration(this.props.configuration, stepsConfig.head_device_selector_screen);
                }
              },
              title: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.title'),
              text: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.body'),
              cancelText: I10n.get('app.action.no'),
              submitText: I10n.get('app.action.yes'),
            }
          });
        }
        else {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(stepsConfig.head_device_selector_screen);
          } else {
            this.props.preSaveConfiguration(this.props.configuration, stepsConfig.head_device_selector_screen);
          }
        }
      }, active: true, done: true },
      { action: () => {
        if (configurationStatuses.finished === this.props.configuration.status) {
          this.props.setActiveStep(stepsConfig.configuration_editor_screen);
        } else {
          this.props.preSaveConfiguration(this.props.configuration, stepsConfig.configuration_editor_screen);
        }
       }, active: true , done: true},
      { action: () => {
        if (configurationStatuses.finished === this.props.configuration.status) {
          this.props.cancel()
        } else {
          this.props.preSaveConfiguration(this.props.configuration, stepsConfig.power_supply);
        }

       }, active: config.canUsePowerSupply(), hidden: config.starterType === possible_starter_selections.PAC, done: config.hasPowerSupplies(), skipped: config.canUsePowerSupply() && !config.hasPowerSupplies() },
      { action: () => { }, active: true, done: isSaved, skipped: isSaved && !config.hasDeviceAccessorized() && !config.hasSoftwareLicenseSelection() },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.continue();
          } else {
            const config = new Configuration(this.props.configuration);
            if (!config.allDevicesHaveRecommandedAccessories()) {
              this.props.openModal({
                modalType: 'confirmation',
                modalProps: {
                  onCancel: () => {
                    this.props.closeModal();
                  },
                  onSubmit: () => {
                    this.props.saveConfiguration(this.props.configuration).then(() => {
                      this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'succes', null);
                    }).catch(() => { });
                    this.props.closeModal();
                  },
                  title: I10n.get('screen.accessorize_screen.recommanded_label'),
                  text: I10n.get('screen.accessorize_screen.recommanded_modal.text'),
                  cancelText: I10n.get('app.action.return'),
                  submitText: I10n.get('app.action.continue'),
                }
              });
            } else {
              this.props.saveConfiguration(this.props.configuration).then(() => {
                this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
              }).catch(() => { });
            }

          }
        }, active: true, done: isSaved
      },
    ];
  }

  performAddToCart = (config) => {
    if (configurationStatuses.finished !== this.props.configuration.status) {
      this.props.saveConfigurationWithoutStepChange(this.props.configuration).then(() => {}).catch(() => { });
    }

    if (appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable) {
      this.props.exportToMyProject(config);
    } else {
      const x = this.props.exportToMyProduct(config);
      x.then(() => {
        if (window.top === window.self) {
          this.props.showNotification(
            I10n.get('add_to_my_product.notification'),
            'success',
            () => (
              <Button onClick={() => { window.open(getCartUrl(), '_blank'); }}>
                {I10n.get('add_to_my_product.notification.button')}
              </Button>
            )
          );
        }
      }).catch(() => {
        this.props.showNotification(
          I10n.get('add_to_my_product.notification.error'),
          'error'
        );
      });
    }
  }

  handleAddToMyProductAction = (config) => {
    if (config.containsPrecommercializedProducts()) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            this.performAddToCart(config);
            this.props.closeModal();
          },
          title: I10n.get('important_information'),
          text: I10n.get((appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable || appConfiguration.launchFromWorkspace) ? 'precommercialized_products_warning.body.project_builder' : 'precommercialized_products_warning.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      this.performAddToCart(config);
    }
  }

  renderAddToMyProductButton = () => {
    const config = new Configuration(this.props.configuration);

    return (
      <AddToMyProductButton
        distributorAddToMyProductLabel={appConfiguration.addToMyProductLabel}
        seamlessSession={appConfiguration.seamlessSession}
        launchFromWorkspace={appConfiguration.launchFromWorkspace}
        isWorkspaceAvailable={appConfiguration.isWorkspaceAvailable}
        unifiedCheckoutAvailable={appConfiguration.unifiedCheckoutAvailable}
        disabled={this.props.export.my_product.isLoading || this.props.configurationSaver.isSaving}
        callback={() => {
          this.handleAddToMyProductAction(config);
        }}
        fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
        expandOnStart={this.props.showButtonAnimations?.addToMyProduct}
      >
      </AddToMyProductButton>
    );
  }

  renderNavigationButtonSection = () => {
    const config = new Configuration(this.props.configuration);
    const canContinue = !this.props.configurationSaver.isSaving;
    const buttons = <>
      <CancelWrapper>
        <Button
          disabled={this.props.configurationSaver.isSaving}
          onClick={() => {
            if (config.canUsePowerSupply()) {
              if (configurationStatuses.finished === this.props.configuration.status) {
                this.props.cancel();
              } else {
                this.props.preSaveConfiguration(this.props.configuration, stepsConfig.power_supply);
              }
            } else {
              if (configurationStatuses.finished === this.props.configuration.status) {
                this.props.setActiveStep(stepsConfig.configuration_editor_screen);
              } else {
                this.props.preSaveConfiguration(this.props.configuration, stepsConfig.configuration_editor_screen);
              }
            }
          }}
        >
          {I10n.get('app.action.back')}
        </Button>
      </CancelWrapper>
      {canContinue ? <Button
        id='accessorize-screen-continue-button'
        importance="emphasized"
        primary
        onClick={event => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.continue();
          } else {
            const config = new Configuration(this.props.configuration);
            if (!config.allDevicesHaveRecommandedAccessories()) {
              this.props.openModal({
                modalType: 'confirmation',
                modalProps: {
                  onCancel: () => {
                    this.props.closeModal();
                  },
                  onSubmit: () => {
                    this.props.saveConfiguration(this.props.configuration).then(() => {
                      this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
                    }).catch(() => { });
                    this.props.closeModal();
                  },
                  title: I10n.get('screen.accessorize_screen.recommanded_label'),
                  text: I10n.get('screen.accessorize_screen.recommanded_modal.text'),
                  cancelText: I10n.get('app.action.return'),
                  submitText: I10n.get('app.action.continue'),
                }
              });
            } else {
              this.props.saveConfiguration(this.props.configuration).then(() => {
                this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
              }).catch(() => { });
            }
          }
        }}
      >
        {I10n.get('app.action.continue')}
      </Button> : <LoadingSpinner width="25px" height="25px"></LoadingSpinner>}
    </>;
    return (
      <>
        <FullScreenNavigationButtonSection>
          <NavigationButtonRow>
            {buttons}
          </NavigationButtonRow>
        </FullScreenNavigationButtonSection>
        <HiddenNavigationButtonSection>
          {buttons}
        </HiddenNavigationButtonSection>
      </>
    );
  }

  renderRangeRules = (rangeInfo) => {
    return (
      <RulesDisplayer
        openModal={this.props.openModal}
        closeModal={this.props.closeModal}
        rangeName={rangeInfo.rangeName}
        starterType={this.props.configuration.starterType}
      >
      </RulesDisplayer>
    );
  }

  clearCBRCategory = (category) => {
    const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));
    if (newValue.selectedItems[category]) {
      newValue.selectedItems[category] = {};
    }

    this.props.setCallByRangeSelectedItems(newValue);
  }

  renderScreenContent = (config) => {
    return (
      <>
        <ScreenContent fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          {this.renderHeaderContent(config)}
          {this.renderMainSection(config)}
          <Notification>
          </Notification>
          {this.renderAddToMyProductButton()}
          {(window.self === window.parent || appConfiguration.showDistributorSurvey) && !this.props.survey.isLoading && <Survey
            appTitle={I10n.get('app.title.' + this.props.configuration.starterType)}
            surveyData={this.props.survey?.surveyData}
            getLabel={(key) => I10n.get(key)}
            preselectionnedAnswers={{ 'embedded_survey.choose_a_category': 'embedded_survey.step.accessorize_step' }}
            onOpen={() => {
              logSurveyOpenEvent(surveyEventTypes.intermediate_open, config.id, stepsConfig.accessorize);
             }}
            onSubmit={(surveyAnswers) => {
              logSurveySubmitEvent(surveyEventTypes.intermediate_sent, config.id, stepsConfig.accessorize, surveyAnswers);
            }}
            fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
            color={appConfiguration.globalStyles.secondaryColor}
          ></Survey>}
        </ScreenContent>
      </>
    );
  }

  renderWithEventualScrollBar = (screenContent) => {
    return ((this.state.isDesktop && !this.props.applicationParameters.fullScreenEnabled) ? <>{screenContent}</> : <Scrollbars>
      <FullScreenScrollbarWrapper>
        {screenContent}
      </FullScreenScrollbarWrapper>
    </Scrollbars>);
  }

  render = () => {
    const config = new Configuration(this.props.configuration);
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    return (
      <Wrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title={I10n.get('app.title.' + this.props.configuration.starterType)}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          setApplicationParameters={this.props.setApplicationParameters}
          userName={appConfiguration.seamlessSession?.name}
          goToStartPage={
            () => {
              this.confirmationBeforeCancel(isSaved, this.props.backToStart);
            }}
          applicationParameters={this.props.applicationParameters}
          steps={getStepperLabels(config.starterType)}
          activeStep={stepsConfig.accessorize}
          stepperActions={this.getStepperActions(isSaved)}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={this.props.configurationSaver.isSaving}
          mySchneiderLink={buildMySchneiderUrl()}
          isSoftwareLicenseConfiguration={false}
          showPrecommWarning={this.props.configuration.showPrecommercializedProducts || config.containsPrecommercializedProducts()}
        ></ApplicationFullHeader>
        {this.renderWithEventualScrollBar(this.renderScreenContent(config))}
        {this.renderNavigationButtonSection()}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    getAccessories: (moduleId) => dispatch(getAccessories(moduleId)),
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    renameConfiguration: (configId, name) => dispatch(renameConfiguration(configId, name)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    continue: () => dispatch(setActiveStep(stepsConfig.save_screen)),
    cancel: () => dispatch(setActiveStep(stepsConfig.power_supply)),
    backToStart: () => dispatch(setActiveStep(stepsConfig.start_screen)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    preSaveConfiguration: (configuration, step) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finalized, step)),
    saveConfiguration: (configuration) => dispatch(preSaveConfiguration(configuration)),
    saveConfigurationWithoutStepChange: (configuration) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finished, configuration.step)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement)),
    addAccessoryCartToMultipleModules: (configuration, moduleId, islandSlot, rackLocation, moduleType, accessoryCart, slotsToAdd) => dispatch(addAccessoryCartToMultipleModules(configuration, moduleId, islandSlot, rackLocation, moduleType, accessoryCart, slotsToAdd)),
    removeModuleOption: (configuration, rackLocation, accessoryType, targetSlot, moduleType, accessory) => dispatch(removeModuleOption(configuration, rackLocation, accessoryType, targetSlot, moduleType, accessory)),
    removeIslandModuleOption: (configuration, islandSlot, rackLocation, accessoryType, targetSlot,  moduleType, accessory) => dispatch(removeIslandModuleOption(configuration, islandSlot, rackLocation, accessoryType, targetSlot, moduleType, accessory)),
    getSurvey: () => dispatch(getSurvey(surveyTypes.intermediate)),
    exportToMyProduct: (configuration) => dispatch(exportToMyProduct(configuration)),
    resetCallByRangeSelectedItems: () => dispatch(resetCBRSelectedItems()),
    exportToMyProject: (configuration) => dispatch(exportToMyProject(configuration)),
    updateShowButtonAnimations: () => dispatch(updateShowButtonAnimations({addToMyProduct: false, survey: false})),
    addSubAccessory: (configuration, slotsToUpdate, moduleType, newAccessory, subAccessory, quantity, islandSlot, rackLocation) => dispatch(addSubAccessory(configuration, slotsToUpdate, moduleType, newAccessory, subAccessory, quantity, islandSlot, rackLocation)),
    removeSubAccessory: (configuration, slotsToUpdate, moduleType, accessoryToRemove, subAccessoryToRemove, islandSlot, rackLocation) => dispatch(removeSubAccessory(configuration, slotsToUpdate, moduleType, accessoryToRemove, subAccessoryToRemove, islandSlot, rackLocation)),
    clearSoftwareLicenseInformations: (softwareToClear) => dispatch(clearSoftwareLicenseInformations(stepsConfig.accessorize, softwareToClear))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessorizeScreen);
